export const UPDATE_JOURNEY_ANALYTICS_STATE = "UPDATE_JOURNEY_ANALYTICS_STATE"
